import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { animated, useIsomorphicLayoutEffect, useSpring } from 'react-spring';
import { styled } from 'styled-components';
import { border, compose, layout } from 'styled-system';
import { ignoredProps } from "../../theme/src";
export const transparentGif = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
export const Image = forwardRef((_a, ref) => {
    var { fallback, height, onError, onLoad, src, style, width } = _a, otherProps = __rest(_a, ["fallback", "height", "onError", "onLoad", "src", "style", "width"]);
    const [imgSpring, api] = useSpring(() => ({
        opacity: 0,
    }));
    useIsomorphicLayoutEffect(() => {
        api.start({
            from: {
                opacity: 0,
            },
            to: {
                opacity: 1,
            },
        });
    }, []);
    const handleError = (event) => {
        if (event.target.src === fallback) {
            event.target.src = transparentGif;
        }
        else {
            event.target.src = fallback || transparentGif;
            if (!fallback) {
                onError === null || onError === void 0 ? void 0 : onError(event);
            }
        }
    };
    return (_jsx(StyledImg, Object.assign({ height: height, loading: "lazy", onError: handleError, onLoad: onLoad, ref: ref, src: src, style: Object.assign(Object.assign({}, (!(style === null || style === void 0 ? void 0 : style.opacity) && imgSpring)), style), width: width }, otherProps)));
});
const StyledImg = styled(animated.img).withConfig({
    shouldForwardProp: (prop) => !ignoredProps.includes(prop),
})(compose(layout, border));
//# sourceMappingURL=Image.js.map